import Cookies from 'js-cookie';

export const openBanner = bannerElement => {
  if (bannerElement) {
    bannerElement.classList.add('-open');
  }
};

export const closeBanner = bannerElement => {
  if (bannerElement && bannerElement.classList.contains('-active')) {
    bannerElement.classList.remove('-active');
    Cookies.set('producthuntBannerClose', '1', `${window.location.hostname}`);
  }
};

export const bannerDaring = () => {
  const bannerElement = document.querySelector('.daringfireball-banner');

  if (bannerElement) {
    setTimeout(() => {
      openBanner(bannerElement);
    }, 1000);
  }
};

export const producthuntBanner = () => {
  const bannerElement = document.querySelector('.producthunt-banner');

  if (bannerElement) {
    const closeButtonElements = bannerElement.querySelectorAll('.producthunt-banner-close');

    [].forEach.call(closeButtonElements, closeButton => {
      closeButton.addEventListener('click', (event) => {
        event.preventDefault();
        closeBanner(bannerElement);
      });
    });
  }
};